import { CustomSelect } from "@/components/CustomSelect/CustomSelect";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { hasStringKey } from "@/utils/misc";
import Label from "@ingka/label";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  options: Record<string, string>;
  disabled: boolean;
};

const Language = ({ options, disabled }: Props) => {
  const { activeAsset, updateMetadata, isMetadataUpdating } =
    useMetadataFields();
  const isUpdating = isMetadataUpdating(activeAsset.id!, "language");

  const selectedValue = activeAsset.language || "";

  return (
    <>
      <Label
        htmlFor="language-select"
        label={
          <LabelWithToolTip
            labelText="Language"
            toolTipText="If the asset has been created in a specific language, please fill this out here."
          />
        }
      />
      <CustomSelect
        id="language-select"
        disabled={disabled || isUpdating}
        value={{ label: options[selectedValue], value: selectedValue }}
        options={Object.entries(options).map(([value, label]) => ({
          value,
          label,
        }))}
        onChange={(option) => {
          if (hasStringKey("value", option)) {
            updateMetadata({
              language: option.value,
            });
          }
        }}
      />
    </>
  );
};

export default Language;
